import * as React from 'react';

const QuoteDownIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height={72} viewBox="0 0 72 72" width={72} xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M42 48C42 42.3431 42 39.5148 43.7574 37.7574C45.5147 36 48.3431 36 54 36C59.6569 36 62.4853 36 64.2426 37.7574C66 39.5148 66 42.3431 66 48C66 53.6569 66 56.4853 64.2426 58.2426C62.4853 60 59.6569 60 54 60C48.3431 60 45.5147 60 43.7574 58.2426C42 56.4853 42 53.6569 42 48Z"
            fill="#BEBEBE"
            stroke="#BEBEBE"
            strokeWidth={1.5}
        />
        <path
            d="M44 51V37.5537C44 25.6359 51.5471 15.5289 62 12"
            stroke="#BEBEBE"
            strokeLinecap="round"
            strokeWidth={5.5}
        />
        <path
            d="M6 48C6 42.3431 6 39.5148 7.7574 37.7574C9.5148 36 12.3432 36 18 36C23.6568 36 26.4852 36 28.2426 37.7574C30 39.5148 30 42.3431 30 48C30 53.6569 30 56.4853 28.2426 58.2426C26.4852 60 23.6568 60 18 60C12.3432 60 9.5148 60 7.7574 58.2426C6 56.4853 6 53.6569 6 48Z"
            fill="#BEBEBE"
            stroke="#BEBEBE"
            strokeWidth={1.5}
        />
        <path
            d="M8 51V37.5537C8 25.6359 15.5471 15.5289 26 12"
            stroke="#BEBEBE"
            strokeLinecap="round"
            strokeWidth={5.5}
        />
    </svg>
);
export default QuoteDownIcon;
